import React from 'react';
import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import { Paperclip } from 'lucide-react';

export const Annexure = Node.create({
  name: 'annexure',

  group: 'block',
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      id: { default: null },
      title: { default: 'Annexure A' },
      content: { default: '' },
      index: { default: 0 },
    };
  },

  parseHTML() {
    return [{ tag: 'annexure-block' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      {
        class: 'border rounded-xl bg-slate-50 p-3 my-3 border-slate-200',
      },
      HTMLAttributes.title,
    ];
  },

  addCommands() {
    return {
      insertAnnexure:
        () =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: {
              id: crypto.randomUUID(),
              title: 'Annexure A',
              content: '',
              index: 0,
            },
          });
        },
    };
  },
});
function AnnexureView({ node, getPos }) {
  const onDragStart = (e) => {
    try {
      const from = typeof getPos === 'function' ? getPos() : null;

      const payload = JSON.stringify({
        type: 'editor-drag',
        nodeType: 'annexure',
        from,
        id: node.attrs.id,
      });

      e.dataTransfer.setData('application/x-rp-editor', payload);
      e.dataTransfer.setData('text/plain', payload);
    } catch (err) {
      console.log('error', err.message);
    }
  };

  return (
    <NodeViewWrapper
      draggable
      onDragStart={onDragStart}
      className="
        my-3 rounded-xl border border-slate-200 bg-slate-50 shadow-sm
      "
    >
      {/* Header */}
      <div className="flex items-center gap-2 border-b border-slate-200 px-4 py-3">
        <span className="flex h-6 w-6 items-center justify-center rounded-md bg-slate-200 text-slate-600">
          <Paperclip className="h-3.5 w-3.5" />
        </span>

        <span className="text-sm font-semibold text-slate-700">
          {node.attrs.title}
        </span>
      </div>

      {/* Body */}
      <div className="p-4">
        <textarea
          value={node.attrs.content}
          onChange={(e) =>
            node.updateAttributes({
              content: e.target.value,
            })
          }
          placeholder="Write annexure content..."
          className="
            w-full rounded-lg border border-slate-200 px-3 py-2 text-sm
            focus:border-[#375AE7]/50 focus:ring-2 focus:ring-[#375AE7]/15
          "
        />
      </div>
    </NodeViewWrapper>
  );
}

Annexure.addNodeView = () => ReactNodeViewRenderer(AnnexureView);
